import type { Category, Direction, Market, Signal } from "@shared/schema/signal";

export type View = "brief" | "feed" | "matrix";
export type MarketFilter = Market | "ALL";
export type CategoryFilter = Category | "ALL";

export function directionGlyph(direction: Direction): string {
  if (direction === "up") return "↑";
  if (direction === "down") return "↓";
  return "→";
}

export function formatChange(value: number | undefined): string {
  if (value === undefined) return "—";
  return `${value > 0 ? "+" : ""}${value.toFixed(2)}%`;
}

export function formatTime(timestamp: string): string {
  const date = new Date(timestamp);
  return Number.isNaN(date.getTime())
    ? timestamp
    : new Intl.DateTimeFormat("zh-CN", { month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false }).format(date);
}

export function rankSignals(signals: Signal[]): Signal[] {
  return [...signals].sort((a, b) =>
    b.anomalyScore - a.anomalyScore
    || b.persistence - a.persistence
    || b.timestamp.localeCompare(a.timestamp));
}
